import { createRequestTypes } from '../utils';

export const FETCH_PRODUCT_CLP_FOR_PRODUCT = createRequestTypes('productClp/FETCH_PRODUCT_CLP');
